// src/pages/subscription/BundleCreatePage.tsx
// Legacy route kept resolvable for old links/bookmarks. Bundle creation now
// happens through BundleFormDialog (form-kit), opened from BundleListPage's
// "Create bundle" — see docs/ux/14-forms.md. This route just sends people there.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const BundleCreatePage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/subscriptions/bundles', { replace: true });
  }, [navigate]);
  return null;
};

export default BundleCreatePage;
